import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class Vguider extends Vue {
  @Prop({ default: () => {} })
    value: DisplayVGuiderData;

  @Prop({ default: false })
    disabled: boolean;

  data: DisplayVGuiderData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc.enterPic = res.content;
  }

  render(h) {
    return (
      <div class="container" style="margin: 10px 20px" key={this.data.sort}>
        <el-checkbox v-model={this.data.desc.isShowApplyEntrance} true-label={1} false-label={0}>
          开启分销员申请入口
        </el-checkbox>
        <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc.enterPic} maxSize={300} />
        <p class="tip blockTip">注1：&nbsp;建议图片分辨率为 750px*300px,不超过300K;</p>
        <p class="tip blockTip">注2：&nbsp;支持jpg、png、gif格式图片;</p>
      </div>
    );
  }
}
